import _ from "lodash"


// Removes password-related fields ("staff_account_password", "staff__password_update")
// from all blocks, unless the template is "account_preferences" — where those fields
// are intentionally rendered and managed by the PasswordUpdate component.
const CONDITIONAL_PASSWORD_FIELDS_TO_REMOVE = ["staff_account_password", "staff__password_update"];
const PASSWORD_FIELDS_TO_REMOVE = ["participant_account_password", "participant__password_update"];

export default function sanitizeTemplateBlocks(templateName, blocks) {
  if (!templateName || !blocks) {
    return [];
  }
  const fieldsToRemove = [...PASSWORD_FIELDS_TO_REMOVE];
  if (templateName !== "account_preferences") {
    fieldsToRemove.push(...CONDITIONAL_PASSWORD_FIELDS_TO_REMOVE);
  }
  // deep clone to avoid mutating original data and apply filtering in one pass
  return _.map(_.cloneDeep(blocks), (block) => ({
    ...block,
    fields: _.reject(block.fields, (field) =>
      fieldsToRemove.includes(field.field_name)
    ),
  }));
}
